export default __webpack_public_path__ + "static/media/flag-korea-(republic-of).8ea0113e.svg";